import React, { useState } from 'react'
import { Button, IconButton } from '@mui/material'
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { useSnackbar } from 'notistack';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import useSubmitLock from '../../hooks/useSubmitLock';

const { REACT_APP_API_URL } = process.env;

const SwitchTipoEliminarIncidencias = (props) => {
    const { tipo } = props
    const { subtipo } = props
    const { data } = props
    const { obtenerdatolote } = props
    const { lote } = props

    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const { enqueueSnackbar } = useSnackbar();
    const { submitting, runWithSubmitLock } = useSubmitLock();

    const handleClickVariant = (resultado) => {
        const variant = resultado.variant
        const msg = resultado.errores || resultado.msg
        enqueueSnackbar(msg, { variant });
    };

    const eliminarpercepcion = (e) => runWithSubmitLock(async () => {
        const token = sessionStorage.getItem('%t')
        var myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${token}`);
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify({
            idmovtopdo: e
        });
        var requestOptions = {
            method: 'DELETE',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        };
        try {
            const response = await fetch(`${REACT_APP_API_URL}/pdim/percepcion`, requestOptions)
            const resultado = await response.json();
            return (handleClickVariant(resultado), obtenerdatolote(lote), setOpen(false))
        } catch (error) {
            console.log('Algo salio mal', error);
        }
    })

    const eliminardeduccion = (e) => runWithSubmitLock(async () => {
        const token = sessionStorage.getItem('%t')
        var myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${token}`);
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify({
            idmovtopermanente: e
        });
        var requestOptions = {
            method: 'DELETE',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        };
        try {
            const response = await fetch(`${REACT_APP_API_URL}/pdim/deduccion`, requestOptions)
            const resultado = await response.json();
            return (handleClickVariant(resultado), obtenerdatolote(lote), setOpen(false))
        } catch (error) {
            console.log('Algo salio mal', error);
        }
    })

    const eliminarmovimiento = (e) => runWithSubmitLock(async () => {
        const token = sessionStorage.getItem('%t')
        var myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${token}`);
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify({
            idmovimiento: e
        });
        var requestOptions = {
            method: 'DELETE',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        };
        try {
            const response = await fetch(`${REACT_APP_API_URL}/pdim/movimiento`, requestOptions)
            const resultado = await response.json();
            return (handleClickVariant(resultado), obtenerdatolote(lote), setOpen(false))
        } catch (error) {
            console.log('Algo salio mal', error);
        }
    })

    const eliminarincidencia1 = (e) => runWithSubmitLock(async () => {
        const token = sessionStorage.getItem('%t')
        var myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${token}`);
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify({
            idmovtosdyh: e
        });
        var requestOptions = {
            method: 'DELETE',
            headers: myHeaders,
            body: raw,
            redirect: 'follow'
        };
        try {
            const response = await fetch(`${REACT_APP_API_URL}/pdim/incidencia`, requestOptions)
            const resultado = await response.json();
            return (handleClickVariant(resultado), obtenerdatolote(lote), setOpen(false))
        } catch (error) {
            console.log('Algo salio mal', error);
        }
    })



    switch (tipo) {
        case 'Percepcion':
            return (
                <>
                    <Dialog
                        open={open}
                        onClose={handleClose}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <DialogTitle id="alert-dialog-title">
                            {"¿Estas seguro de eliminar?"}
                        </DialogTitle>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description">
                                Nombre:  {data.nombrelargo}
                            </DialogContentText>
                            <DialogContentText id="alert-dialog-description">
                                Incidencia:  {data.subtipo}
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button variant='contained' color='success' disabled={submitting} onClick={e => eliminarpercepcion(data.idmovtopdo)}>Aceptar</Button>
                            <Button onClick={handleClose} autoFocus>
                                Cancelar
                            </Button>
                        </DialogActions>
                    </Dialog>
                    <IconButton onClick={handleClickOpen}>
                        <DeleteForeverIcon />
                    </IconButton>
                </>
            )
            break;
        case 'Deduccion':
            return (
                <>
                    <Dialog
                        open={open}
                        onClose={handleClose}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <DialogTitle id="alert-dialog-title">
                            {"¿Estas seguro de eliminar?"}
                        </DialogTitle>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description">
                                Nombre:  {data.nombrelargo}
                            </DialogContentText>
                            <DialogContentText id="alert-dialog-description">
                                Incidencia:  {data.subtipo}
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button variant='contained' color='success' disabled={submitting} onClick={e => eliminardeduccion(data.idmovtopermanente)}>Aceptar</Button>
                            <Button onClick={handleClose} autoFocus>
                                Cancelar
                            </Button>
                        </DialogActions>
                    </Dialog>
                    <IconButton onClick={handleClickOpen}>
                        <DeleteForeverIcon />
                    </IconButton>
                </>
            )
            break;
        case 'Incidencia':
            return (
                <><Dialog
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        {"¿Estas seguro de eliminar?"}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            Nombre:  {data.nombrelargo}
                        </DialogContentText>
                        <DialogContentText id="alert-dialog-description">
                            Incidencia:  {data.subtipo}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button variant='contained' color='success' disabled={submitting} onClick={e => eliminarincidencia1(data.idmovtosdyh)}>Aceptar</Button>
                        <Button onClick={handleClose} autoFocus>
                            Cancelar
                        </Button>
                    </DialogActions>
                </Dialog>
                    <IconButton onClick={handleClickOpen}>
                        <DeleteForeverIcon />
                    </IconButton>
                </>
            )
            break;
        case 'Movimiento':
            return (
                <><Dialog
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        {"¿Estas seguro de eliminar?"}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            Nombre:  {data.nombrelargo}
                        </DialogContentText>
                        <DialogContentText id="alert-dialog-description">
                            Incidencia:  {data.subtipo}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button variant='contained' color='success' disabled={submitting} onClick={e => eliminarmovimiento(data.idmovimiento)}>Aceptar</Button>
                        <Button onClick={handleClose} autoFocus>
                            Cancelar
                        </Button>
                    </DialogActions>
                </Dialog>
                    <IconButton onClick={handleClickOpen}>
                        <DeleteForeverIcon />
                    </IconButton>
                </>
            )
            break;
        default:
            break;
    }

}

export default SwitchTipoEliminarIncidencias
